<template>
    <rkm-modal
        :buttons="['cancel']"
        :loading="loading"
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        open(item) {

            this.items = [
                {
                    field: 'Data',
                    value: item.data,
                },
                {
                    field: 'Motivo',
                    value: item.motivoDescricao,
                },
                {
                    field: 'Justificativa',
                    value: item.justificativa || '-',
                },
                {
                    field: 'Usuário solicitante',
                    value: item.usuarioSolicitanteNome || '-',
                },
                {
                    field: 'Usuário que realizou a baixa',
                    value: item.usuarioBaixaNome,
                },
                {
                    field: 'Quantidade',
                    value: item.quantidade,
                },
            ]

            if (item.usuarioEstornoNome) {

                this.items.push({
                    field: 'Usuário que realizou o estorno',
                    value: item.usuarioEstornoNome,
                })

                this.items.push({
                    field: 'Data do estorno',
                    value: item.dataEstorno,
                })
            }

            this.$refs.Modal.show()
        },
    }
}
</script>